import { TGetWishlistSuggestions } from '@daymade/api-contracts';
import ImageWithText from 'components/common/ImageWithText';
import RoundedButton from 'components/RoundedButton';
import Heart from '../../svg/Heart40.svg';
import styles from './YourWishlist.module.css';

const SuggestedPrize = ({
  prize,
  favouritePrize,
}: {
  prize: TGetWishlistSuggestions[number];
  favouritePrize: () => void;
}) => {
  return (
    <ImageWithText
      imageSrc={prize.heroImageLocation}
      imageOverlayChildren={
        <button className={styles.favourited} onClick={favouritePrize}>
          {<Heart />}
        </button>
      }
      textChildren={
        <>
          <div className={styles.suggested + ' textLightGrey'}>Suggested</div>
          <div className={styles.suggestedTitle}>{prize.title}</div>
          <RoundedButton
            colorStyle="OutlineDark"
            onClick={favouritePrize}
            rebrandDm2025
            mini
            className={styles.suggestedButton}
          >
            ADD
          </RoundedButton>
        </>
      }
    />
  );
};

export default SuggestedPrize;
